<template>
  <div ref="thumbnail" class="thumbnail-component">
    <div v-show="loading" class="image-mask-container">
      <img
        src="../../../../public/images/common/default-placeholder.png"
        class="mask-img"
      />
    </div>
    <template v-show="!loading">
      <!--圖片邏輯-->
      <template v-if="model.type === 1 && isMounted">
        <crop-item
          class="crop-item"
          :filter="filter"
          :thumbnail="true"
          :model="model.crop"
          :style="cropStyle"
          :backgroundColor="backgroundColor"
        ></crop-item>
      </template>
      <!--視頻邏輯-->
      <template v-if="model.type === 2">
        <div
          v-show="cover"
          :style="{ 'background-image': `url(${this.model.coverUrl})` }"
          class="edit-image-container"
        >
          <div class="video-icon" v-show="isVideo"></div>
        </div>
        <hi-video
          v-show="!cover"
          :poster="model.coverUrl"
          :src="model.url"
          style="width: 100%; height: 100%"
        ></hi-video>
      </template>
      <div class="mul-icon" v-if="mul"></div>
    </template>
    <slot></slot>
  </div>
</template>

<script>
import hiVideo from "../../common/media/Video";
import { imageLoad } from "../../../utils/media";
import { sleep } from "../../../utils";
import CropItem from "../../../components/media/crop/CropItem";

export default {
  name: "MediaCropThumbnailsComponent",
  components: { hiVideo, CropItem },
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    filter: {
      type: String,
    },
    cover: {
      type: Boolean,
      default: true,
    },
    mul: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
    },
  },
  data() {
    return {
      isMounted: false,
      loading: true, // 图片正加载中
    };
  },
  computed: {
    cropStyle() {
      const { clientHeight, clientWidth } = this.$refs.thumbnail;
      let cropSize = 0;
      if (clientHeight > clientWidth) {
        cropSize = clientHeight;
      } else {
        cropSize = clientWidth;
      }
      return {
        width: `${cropSize}px`,
        height: `${cropSize}px`,
        position: "abso",
      };
    },
    /**
     * 是否为视频
     */
    isVideo() {
      return this.model.type === 2;
    },
    /**
     * 計算url地址,縮略還是高清
     */
    url() {
      if (this.cover) {
        return this.model.url;
      } else {
        return this.model.url;
      }
    },
    /**
     * 是否为修改状态
     */
    edit() {
      return this.model.from === "edit";
    },
  },
  async mounted() {
    this.isMounted = true;
    // 如果是視頻的詳情則直接不顯示loading
    if (this.model.type === 2 && !this.cover_key) {
      this.loading = false;
      return;
    }
    this.loading = true;
    // 添加图片占位图逻辑，图片加载中显示loading,加载完撤销loading
    await imageLoad({ image: this.$refs.image });
    await sleep({ time: 500 });
    this.loading = false;
  },
  created() {
    this.isMounted = false;
  },
};
</script>

<style lang="less" scoped>
.crop-item {
  position: absolute;
}

.image-mask-container {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: #e9eef1;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;

  .mask-img {
    width: 50%;
    max-width: 60px;
    display: block;
  }
}

.thumbnail-component {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: rgb(140, 140, 140);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  .thumbnail-image-container {
    height: 100%;
    width: 100%;

    .container {
      position: absolute;
      top: 50%;
      left: 50%;
      overflow: hidden;
      transform-origin: top left;
    }
  }

  .edit-image-container {
    width: 100%;
    height: 100%;
    background-color: #e5e5e5;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;

    .video-icon {
      width: 65%;
      padding-bottom: 65%;
      z-index: 2;
      background-size: cover;
      background-image: url("../../../../public/images/schedule_posts/list/video.png");
    }
  }

  .mul-icon {
    background-image: url("../../../../public/images/library/album@3x.png");
    width: 10px;
    height: 10px;
    background-size: contain;
    background-position: center;
    position: absolute;
    right: 2px;
    top: 2px;
  }
}
</style>
